import React from 'react';
import { usePageSeo, type PageSeoProps } from './usePageSeo.js';

export const SeoHead: React.FC<PageSeoProps> = (props) => {
  usePageSeo(props);
  return null;
};
